import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import devArgsMsg from './modules/devArgsMsg'
import sideNav from './modules/sideNav'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
      user,
      devArgsMsg,
      sideNav
    }
})  


// WEBPACK FOOTER //
// ./src/store/index.js